import { Injectable } from '@angular/core';
import { SprobotconfigService } from './sprobotconfigservice.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private SubscriptionUrl: string;

  constructor(
      private http: HttpClient,
      private sprobotConfigService: SprobotconfigService) { 
        this.SubscriptionUrl = this.sprobotConfigService.getSetting('Cors:AuthAPIPublic').propertyValue;
      }

    postSubToken(token: any): Observable<any>{
      return this.http.post<any>(this.SubscriptionUrl + '/Subscription/RegisterNewSubscription/' + token, null);
    }

    postActivateSub(SubID: any, TenantID: any): Observable<any>{
      return this.http.post<any>(this.SubscriptionUrl + '/Subscription/ActivateSubscription/' + SubID + '/' + TenantID, null);
    }
}
